<template>
  <el-container class="f-h">
    <el-header class="toolbar" style="height: 2.5rem">
      <el-row type="flex" justify="space-between">
        <el-col :span="8" class="sub-title left">
          预检分诊：
          <el-dropdown @command="openDlg" @click="add" size="small" split-button type="primary" :disabled="!permission.registration_precheck_create"
            >患者登记<el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="group" :disabled="!permission.registration_precheck_create">成批分组</el-dropdown-item>
              <el-dropdown-item command="level" :disabled="!permission.registration_precheck_config">分级标准</el-dropdown-item>
              <el-dropdown-item command="setting" :disabled="!permission.registration_precheck_config">通知设置</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
          type="warning"
          icon="el-icon-download"
          size="small"
          class="left-pad"
          @click="exportExcel"
          >导出</el-button
        >
        </el-col>
        
        <el-col :span="16" class="right">
          <el-date-picker style="width: 15rem" size="small" @change="page" v-model="dateRange" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="截止时间"></el-date-picker>
          <el-select clearable v-model="condition.groupId" class="condition-input left-pad" placeholder="请选择成批组" @change="page" size="small" filterable remote :remote-method="searchGrp">
            <el-option v-for="item in grps" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-input size="small" class="left-pad" style="width: 12rem" type="text" clearable placeholder="姓名、证件号" v-model="condition.keyword" @keyup.enter.native="page" @clear="page">
            <el-button size="" slot="append" @click="page" :disabled="meta.loading" icon="el-icon-search"></el-button>
          </el-input>
        </el-col>
      </el-row>
    </el-header>
    <el-table @filter-change="filterChange" @sort-change="sortChange" :data="entities.items" height="100%" v-loading="meta.loading" :row-class-name="warningRow" class="main-table">
      <el-table-column label="就诊号" prop="opNo" min-width="150" align="center">
        <template slot-scope="{ row }">
          <el-link v-if="permission.registration_precheck_edit && !row.ifPreStatus" type="primary" @click="edit(row)">{{ row.opNo || "尚未挂号" }}</el-link>
          <span v-else>{{ row.opNo || "尚未挂号" }}</span>
        </template>
      </el-table-column>
      <el-table-column type="expand" width="20">
        <template slot-scope="{ row }">
          <detail :reg="row" :now="now" />
        </template>
      </el-table-column>
      <el-table-column column-key="criticalLevel" :filters="dictEnum.CriticalLevel" :filter-multiple="false" label="危重等级" min-width="100" prop="criticalLevel" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.criticalLevel == Enum.CriticalLevel.濒危" type="danger" effect="dark" size="small">{{ row.criticalLevel }}</el-tag>
          <el-tag v-else-if="row.criticalLevel == Enum.CriticalLevel.危重" type="danger" hit size="small">{{ row.criticalLevel }}</el-tag>
          <el-tag v-else-if="row.criticalLevel == Enum.CriticalLevel.急症" type="warning" hit size="small">{{ row.criticalLevel }}</el-tag>
          <el-tag v-else type="info" hit size="small">{{ row.criticalLevel }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="姓名" prop="name"> </el-table-column>
      <el-table-column column-key="gender" :filters="dict.Gender" :filter-multiple="false" label="性别" prop="gender" min-width="60" align="center">
        <template slot-scope="scope">
          {{ scope.row.gender | dictText("Gender") }}
        </template>
      </el-table-column>
      <el-table-column label="年龄" prop="patientAge" width="60" align="center">
        <template slot-scope="{ row }">
          {{ row.birthday | age }}
        </template>
      </el-table-column>
      <el-table-column column-key="consciousness" :filters="dict.Consciousness" :filter-multiple="false" label="意识状态" prop="consciousness" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.consciousness | dictText("Consciousness") }}
        </template>
      </el-table-column>
      <el-table-column label="距上次评估" prop="await" min-width="100" align="right">
        <template slot-scope="{ row }">
          <el-link type="primary" :underline="false">{{ waitTime(row) }}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        column-key="ifCombinedInjury"
        :filters="[
          { text: '是', value: true },
          { text: '否', value: false },
        ]"
        :filter-multiple="false"
        label="复合伤"
        prop="ifCombinedInjury"
        width="100"
        align="center"
      >
        <template slot-scope="{ row }">
          {{ row.ifCombinedInjury ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="既往病史" prop="pastHistory" min-width="100">
        <template slot-scope="{ row }">
          {{ row.pastHistory }}
        </template>
      </el-table-column>
      <el-table-column sortable="custom" label="登记时间" prop="enterTime" align="center" min-width="150">
        <template slot-scope="{ row }">
          {{ row.enterTime | fmtDateTime }}
        </template>
      </el-table-column>
      <el-table-column label="成批组" prop="groupName" width="100" align="center"> </el-table-column>
      <el-table-column column-key="ifPreStatus" :filters="[{ text: '已就诊', value: true }]" :filter-multiple="false" label="状态" prop="ifPreStatus" min-width="100" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.ifPreStatus" type="info" size="small" effect="plain">已就诊</el-tag>
          <el-tag v-else type="warning" size="small" effect="plain">未就诊</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="删除" prop="" width="60" align="center">
        <template slot-scope="{ row }">
          <el-button circle size="mini" type="danger" plain icon="el-icon-delete" @click="del(row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- </el-main> -->
    <pagination :entities="entities" @page="page" :condition="condition" />
    <register :reg="entity" :visible.sync="meta.showReg" @close="page"></register>
    <group :visible.sync="meta.showGroup"></group>
    <setting :visible.sync="meta.showSetting" @save="loadSetting"></setting>
    <level :visible.sync="meta.showlevel"></level>
  </el-container>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "vuex";
  import _detail from "./_detail.vue";
  export default {
    components: {
      pagination: () => import("@/components/_com/pagination"),
      register: () => import("./register"),
      group: () => import("./group"),
      setting: () => import("./setting"),
      level: () => import("./level"),
      detail: () => import("./_detail"),
    },
    data() {
      return {
        meta: {
          showlevel: false,
          showGroup: false,
          showSetting: false,
          showReg: false,
          loading: false,
        },
        condition: {
          keyword: "",
          sort: "criticalLevel",
          asc: true,
          pageIndexOnView: 1,
          pageSize: 20,
        },
        setting: {},
        grps: [],
        dateRange: [],
        entities: {},
        entity: null,
        timer: null,
        now: null,
        seconds: 0,
      };
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "Enum", "permission", "user"]),
    },
    mounted() {
      let _this = this;
      this.timer = setInterval((item) => {
        _this.cycle();
      }, 1000);
      this.loadSetting();
      this.page();
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
    methods: {
      cycle() {
        this.now = new Date();
        this.seconds++;
        if (this.seconds % (this?.setting?.queueRefreshRate ?? 30) == 0) {
          this.refreshState();
        }
        if (this.seconds % 60 == 0) {
          this.notify();
        }
      },
      waitTime(row) {
        if (!this.now) {
          return "";
        }
        if (row.ifPreStatus) {
          return "";
        }
        return this.$utils.spanTime(row.assessTime, this.now);
      },
      refreshState() {
        let ids = this.entities.items.filter((i) => !i.ifPreStatus).map((i) => i.patientId);
        if (ids && ids.length) {
          api
            .queryReg({
              patientIds: ids,
            })
            .then((res) => {
              let hasChange = false;

              this.entities.items.forEach((reg) => {
                let item = res.items.find((item) => item.patientId == reg.patientId);
                let needNotifyCriticalLevel = false
                if (item) {
                  needNotifyCriticalLevel = (reg.opNo != item.opNo || reg.criticalLevel != item.criticalLevel)
                  reg.opNo = item.opNo;
                  reg.ifPreStatus = item.state == this.Enum.RegState.就诊 || item.state == this.Enum.RegState.完诊;
                  if (reg.ifPreStatus) {
                    this.$notify({
                      title: "接诊通知",
                      duration: 0,
                      type: "success",
                      message: `${reg.name}，已经就诊。接诊医生：${item.doctorName}，科室：${item.deptName}，接诊时间：${this.$utils.fmtDateTime(item.treatDate)}`,
                    });
                    hasChange = true;
                  }
                  api.saveRegister(reg);
                  if (needNotifyCriticalLevel) {
                    api.updateRegCriticalLavel({
                      opNo: reg.opNo,
                      criticalLevel: reg.criticalLevel,
                    });
                  }
                }
              });

              if (hasChange) {
                setTimeout(() => {
                  this.page();
                }, 2000);
              }
            });
        }
      },
      notify() {
        this.$utils.log("通知医生，濒危，与危重，应该调用后端");
      },
      openDlg(value) {
        switch (value) {
          case "group":
            this.meta.showGroup = true;
            break;
          case "setting":
            this.meta.showSetting = true;
            break;
          case "level":
            this.meta.showlevel = true;
            break;
        }
      },
      filterChange(obj) {
        let key = Object.keys(obj)[0];
        let value = obj[key][0];
        this.condition[key] = value;
        this.page();
      },
      sortChange({ prop, order }) {
        if (order) {
          this.condition.asc = order === "ascending";
          this.condition.sort = prop;
        } else {
          this.condition.asc = true;
          this.condition.sort = "criticalLevel";
        }
        this.page();
      },
      warningRow({ row, rowIndex }) {
        if (row.ifPreStatus) return "";
        if (!JSON.parse(this?.setting?.secondGrade ?? "false")) {
          return "";
        }
        let mintues = this.$utils.spanTime(row.assessTime, this.now, "m");
        switch (row.criticalLevel) {
          case this.Enum.CriticalLevel.濒危:
            if (this.setting.preEndangered && parseInt(mintues) > parseInt(this.setting.preEndangered)) {
              return "warning-row";
            }
            break;
          case this.Enum.CriticalLevel.危重:
            if (this.setting.preCritical && parseInt(mintues) > parseInt(this.setting.preCritical)) {
              return "warning-row";
            }
            break;
          case this.Enum.CriticalLevel.急症:
            if (this.setting.preEmergency && parseInt(mintues) > parseInt(this.setting.preEmergency)) {
              return "warning-row";
            }
            break;
          case this.Enum.CriticalLevel.非急症:
            if (this.setting.preNonEmergency && parseInt(mintues) > parseInt(this.setting.preNonEmergency)) {
              return "warning-row";
            }
            break;
        }
        return "";
      },
      searchGrp(keyword) {
        api
          .getGroup({
            name: keyword,
          })
          .then((res) => {
            this.grps = res.items;
          })
          .catch((err) => {
            console.log(err);
          });
      },
      add() {
        this.entity = null;
        this.meta.showReg = true;
      },
      edit(row) {
        this.entity = this.$utils.clone(row);
        this.meta.showReg = true;
      },
      del(info) {
        this.$confirm("确定要删除此记录！", "删除记录", {
          type: "warning",
        })
          .then(() => {
            this.meta.loading = true;
            api
              .delRegister(info.id)
              .then((res) => {
                this.$message.success("删除成功");
                this.page();
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.meta.loading = false;
              });
          })
          .catch((e) => {});
      },
      formatJson(filterVal, jsonData) {
      return jsonData.map((value) =>
        filterVal.map((key) => {
          return value[key]
        })
      );
    },
      page() {
        this.meta.loading = true;
        if (this.dateRange && this.dateRange.length) {
          this.condition.dateStart = this.dateRange[0];
          this.condition.dateEnd = this.dateRange[1];
        } else {
          this.condition.dateStart = null;
          this.condition.dateEnd = null;
        }
        api
          .queryRegister(this.condition)
          .then((res) => {
            this.entities = res;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
    exportExcel() { // 前端导出
      let _this = this;
        if (this.dateRange && this.dateRange.length) {
          this.condition.dateStart = this.dateRange[0];
          this.condition.dateEnd = this.dateRange[1];
        } else {
          this.condition.dateStart = null;
          this.condition.dateEnd = null;
        }
      api
        .getRegisterExcelExport(this.condition)
        .then((res) => {
          console.log("============================================")
          console.log(res)
          import("@/components/vendor/Export2Excel").then((excel) => {
              const tHeader = [
                "最后评估时间",
                "姓名",
                "性别",
                "年龄",
                "联系电话",
                "详细住址",
                "患者来源",
                "健康(行程)码是否正常",
                "是否有疫区接触史",
                "体温",
                "脉搏",
                "呼吸",
                "血压",
                "病情分级",
                "分区(红/黄/绿)",
                "去向(住院/离院/死亡/转科)",
                "离开时间",
                "签名",
              ]; //要导出后表头是什么，可以跟tableDate中的表头不一致
              const filterVal = [
                "assessTime",
                "name",
                "gender",
                "patientAge",
                "tel",
                "address",
                "patientSource",
                "ifNormalHeathCode",
                "ifContactEpidemicArea",
                "vsBodyTemperature",
                "vsSphygmus",
                "vsBreath",
                "bloodPressure",
                "criticalLevel",
                "emergencyDivision",
                "whereAbouts",
                "leaveTime",
                "vsExtend1",
              ];
              const data = _this.formatJson(filterVal, res);
              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: "预检分诊登记本", //导出文件的名，自定义就好
              });
            });
        })
        .catch((err) => {
          if (err) {
            _this.$message.error(err.message || err);
          }
        });
    },
      loadSetting() {
        api
          .querySetting()
          .then((res) => {
            this.setting = {};
            res.forEach((item) => {
              this.setting[item.code] = item.value;
            });
          })
          .catch((err) => {
            console.log(err);
          });
      },
    },
  };
</script>

<style scoped>
  .wedge-left {
    margin-left: 5px;
  }
  .condition-wide {
    width: 17rem;
  }
  .el-tag--dark {
    border-color: rgba(0, 0, 0, 0);
  }
</style>
<style>
  .warning-row {
    background-color: #dff938 !important;
    /* color: #FFF !important; */
  }
</style>
